<aside class="landing-sidebar">
  <div class="landing-brand-mark" aria-hidden="true"></div>

  <nav class="landing-sidebar-nav" aria-label="Utility navigation">
    <a
      v-for="item in navItems"
      :key="item.label"
      :href="item.href"
      class="landing-sidebar-link"
      :class="{ 'is-active': item.active }"
    >
      <span class="landing-sidebar-icon" aria-hidden="true" v-html="item.icon"></span>
      <span>{{ item.label }}</span>
    </a>
  </nav>
</aside>
